<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24">
    <path
      d="m5.625 16.32 2.557 2.568-1 1-3.432.869.869-3.431 1.006-1.006zm8.97-8.97 2.562 2.563L15 12.07 9.48 17.59l-2.574-2.551 6.232-6.232 1.456-1.456zm5.124-2.562c.669.668.706 1.729.112 2.44l-.112.122-1.277 1.278-2.567-2.559 1.282-1.281a1.812 1.812 0 0 1 2.562 0z"
      :fill="color"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#1D1D20',
    },
    size: {
      type: String,
      default: '24',
    },
  },
}
</script>
